import { render, staticRenderFns } from "./DeviceUptime.vue?vue&type=template&id=81a9427e"
import script from "./DeviceUptime.vue?vue&type=script&lang=js"
export * from "./DeviceUptime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports